import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { ShippingProvider } from '../../interfaces/ShippingProvider/ShippingProvider';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { BoolColumn } from '../../components/DataTable/BoolColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { PriceColumn } from '../../components/DataTable/PriceColumn';

const columns: TableColumn<ShippingProvider>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'name',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.name} />,
  },
  {
    id: 'price',
    name: 'Fiyat',
    accessor: (row) => <PriceColumn value={row.price} />,
  },
  {
    id: 'discounted-price',
    name: 'İndirimli Fiyat',
    accessor: (row) => <PriceColumn value={row.discountedPrice} />,
  },
  {
    id: 'is-active',
    name: 'Durum',
    accessor: (row) => <BoolColumn value={row.isActive} />,
    align: 'center',
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type ShippingProvidersTableProps = {
  shippingProviders: ShippingProvider[];
};

export const ShippingProvidersTable = (props: ShippingProvidersTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.shippingProviders, limit, page),
    [props.shippingProviders, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.shippingProviders.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(sp) => navigate(`/shipping/providers/${sp.id}`)}
    />
  );
};
